import React, {FC, ReactNode} from 'react';
import DynamicAsset from 'components/DynamicAsset';

import * as styles from './styles.module.scss';

interface RowProps {
	children: ReactNode;
}

const MediaLogoRow: FC<RowProps> = () => (
	<div className={styles.wrapper}>
		<div className={styles.logos}>
			<div className={styles.outer}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/c8/aa/c8aa5c562471b0f2' />
			</div>
			<div className={styles.logo}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/27/c2/27c2d2ec2f349792' />
			</div>
			<div className={styles.logo}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/94/2e/942e523cad747c11' />
			</div>
			<div className={styles.emphasize}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/04/d2/04d2e988fd5cd807' />
			</div>
			<div className={styles.logo}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/6f/7d/6f7d40acef50c6ac' />
			</div>
			<div className={styles.logo}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/25/ab/25aba9a6f313a635' />
			</div>
			<div className={styles.outer}>
				<DynamicAsset imageSrc='https://static.bodyspec.com/at/2a/f5/2af53c03b56fbce7' />
			</div>
		</div>
	</div>
);

export default MediaLogoRow;
